<div class="flex w-full h-full shadow-1">
<p class="p-6">Aucun élément à afficher</p>
</div>
